import { render, staticRenderFns } from "./woven_raw_fabric.vue?vue&type=template&id=2a7d734a&scoped=true"
import script from "./woven_raw_fabric.vue?vue&type=script&lang=js"
export * from "./woven_raw_fabric.vue?vue&type=script&lang=js"
import style0 from "./woven_raw_fabric.vue?vue&type=style&index=0&id=2a7d734a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d734a",
  null
  
)

export default component.exports